<template>
    <zone
        auto-height
        align="center"
        class="hero"
        :background-image="images.background"
        :data-label="dico.dataLabel"
        :id="dico.id"
    >
        <heading :level="1" v-html="dico.title" />
        <paragraph :size="sizes.subtitle" v-html="dico.subtitle" />
    </zone>
</template>

<script>
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Zone from 'gvue/src/core/Zone'

import { getBackground } from '@/helpers/visual'

export default {
    name: 'SectionHero',
    components: {
        Heading,
        Paragraph,
        Zone
    },
    computed: {
        images () {
            return { background: getBackground(this.dico.background, 'jpg') }
        },
        sizes () {
            return { subtitle: this.$breakpoint.isS ? 'M' : 'XL' }
        }
    },
    created () {
        this.dico = this.$json.hero
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.hero
    &::after
        content: ''
        position: absolute
        z-index: 0
        top: 0
        right: 0
        bottom: 0
        left: 0
        background-color: $color_black
        opacity: 0.25

.g
    .g_center .g_text
        >
            .g_txt_M,
            .g_txt_XL
                font-weight: 700
                text-transform: uppercase

/deep/
    .g_restrict
        z-index: 1

    .g_bg
        background-size: cover

+mobile
    .g
        .g_center .g_text
            > .g_h1
                font-size: 1.5em
                font-weight: 800
            > .g_txt_M
                font-weight: 700
                letter-spacing: 0.1em
+desktop
    .g
        .g_center .g_text
            > .g_h1
                width: 80%

            > .g_txt_XL
                width: 90%

    /deep/
        .g_content
            padding: ($section_padding * 2) 0
</style>
